import script from "./ImageGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageGrid.vue?vue&type=script&setup=true&lang=js"

import "./ImageGrid.vue?vue&type=style&index=0&id=1fb1108a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fb1108a"]])

export default __exports__